import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    filterOutlets: [],
    filterTypes: [],
    lastQuery: null,
    appList: [],
    outletList: [],
};

const mutations = {
    setFilterOutlets(state, types) {
        state.filterOutlets = types;
    },

    setFilterTypes(state, types) {
        state.filterTypes = types;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },

    setAppList(state, data) {
        state.appList = data;
    },

    setOutletList(state, data) {
        state.outletList = data;
    },
};

const getters = {
    filterOutlets: state => {
        return state.filterOutlets;
    },

    filterTypes: state => {
        return state.filterTypes;
    },
};

const actions = {
    getAppList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    limit: 10,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-app');

        return axios
            .get(Laroute.route('franchise.vue.marketplace-apps'), options)
            .then(res => {
                let data = res.data.data;

                commit('setAppList', data);
                commit('setLastQuery', params.query);
                endLoading(dispatch, 'fetch-app');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-app');

                throw err;
            });
    },

    getAppListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.appList.length || state.lastQuery !== params.query) {
            return dispatch('getAppList', params);
        }

        return Promise.resolve(state.appList);
    },

    getOutletList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    limit: 10,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-outlet');

        return axios
            .get(Laroute.route('franchise.vue.outlets'), options)
            .then(res => {
                let data = res.data.data;

                commit('setOutletList', data);
                commit('setLastQuery', params.query);
                endLoading(dispatch, 'fetch-outlet');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-outlet');

                throw err;
            });
    },

    getOutletListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.appList.length || state.lastQuery !== params.query) {
            return dispatch('getOutletList', params);
        }

        return Promise.resolve(state.appList);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/marketplace-app.js